// "Maak het compleet" rows: checked add-ons ride along with the host product form submit
(function () {
  // an empty fits list never matches: a device claim must be proven
  function filterByFit(items, activeIds, primary) {
    if (!activeIds || !activeIds.length || activeIds.indexOf(primary) !== -1) return items;
    return items.filter(function (it) {
      return (it.fits || []).some(function (id) { return activeIds.indexOf(id) !== -1; });
    });
  }
  // a lens type with no real 3-pack offers 3x its in-stock 1-stuk; the automatic "3 stuks" discount prices it, the page only mirrors its percent
  function addTriple(combos, pctMils) {
    if (!(pctMils > 0 && pctMils <= 100000)) return combos;
    // one synthetic 3-pack per type AND colour: a coloured 1-stuk never borrows the plain colour's real 3-pack
    function tc(c) { return c.type_handle + '|' + (c.color || ''); }
    var hasThree = {}, source = {};
    combos.forEach(function (c) {
      if (c.pack === 3) hasThree[tc(c)] = true;
      if (c.pack === 1 && c.triple && c.available && !source[tc(c)]) source[tc(c)] = c;
    });
    var out = combos.slice();
    Object.keys(source).forEach(function (key) {
      if (hasThree[key]) return;
      var s = source[key];
      out.push({
        fits: s.fits, type_handle: s.type_handle, type_name: s.type_name, color: s.color, pack: 3, qty: 3, synthetic: true, pct_mils: pctMils,
        variant_id: s.variant_id, unit_cents: s.price_cents, price_cents: s.price_cents * 3, available: true, image: s.image
      });
    });
    return out;
  }
  // packs ascending: the smallest one in stock lands first, an all-sold-out type still shows its smallest
  function pickPack(packs, isAvailable) {
    for (var i = 0; i < packs.length; i++) {
      if (isAvailable(packs[i])) return packs[i];
    }
    return packs.length ? packs[0] : null;
  }
  var exported = { filterByFit: filterByFit, addTriple: addTriple, pickPack: pickPack };
  if (typeof window !== 'undefined') window.CMAddonFit = exported;
  if (typeof module !== 'undefined' && module.exports) module.exports = exported;
  if (typeof document === 'undefined') return;

  var root = document.querySelector('[data-cm-addon]');
  if (!root) return;
  var formId = root.getAttribute('data-form-id');
  var form = formId ? document.getElementById(formId) : null;
  if (!form) return;

  var soldOutLabel = root.getAttribute('data-sold-out-label') || '';
  var errorTemplate = root.getAttribute('data-error-template') || '%TITLE%';
  // parseFloat + mils-integer math: fractional percents (12.5) must reprice with the exact floor rule, not truncate to 12
  var promoPctMils = Math.round(parseFloat(root.getAttribute('data-promo-pct')) * 1000);
  var promoOn = promoPctMils > 0 && promoPctMils <= 100000;

  // the Liquid `money` filter renders 123456 in the visitor's currency ("€1.234,56", "1.234,56 kr"); reuse its symbol, order and separators
  var moneySample = root.getAttribute('data-money-sample') || '€1.234,56';
  var moneyParts = moneySample.match(/^(.*?)1(\D?)234(\D)56(.*)$/) || [null, '€', '.', ',', ''];
  function fmtMoney(cents) {
    var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, moneyParts[2]);
    var rem = cents % 100;
    return moneyParts[1] + whole + moneyParts[3] + (rem < 10 ? '0' + rem : rem) + moneyParts[4];
  }
  // PINNED (live-probed): Shopify discounts per UNIT as floor(unit_cents * pct / 100); floor is the safe direction
  function discountedCents(cents, mils) {
    return cents - Math.floor(cents * mils / 100000);
  }
  var promoMils = promoOn ? promoPctMils : 0;
  function renderPrice(el, unitCents, qty, available, mils) {
    if (!available) {
      el.textContent = soldOutLabel;
      return;
    }
    if (mils > 0) {
      el.innerHTML = '<s>' + fmtMoney(unitCents * qty) + '</s> ' + fmtMoney(qty * discountedCents(unitCents, mils));
    } else {
      el.textContent = fmtMoney(unitCents * qty);
    }
  }

  // ── pack rows (the screen row + one per lens type): type/pack selects rewrite the row, nothing is added until submit ──
  function wirePackRow(row) {
    var tripleText = row.getAttribute('data-triple-pct') || '';
    var tripleMils = Math.round(parseFloat(tripleText) * 1000);
    var colorDefault = row.getAttribute('data-color-default') || '';
    // a listing without a colour label (the plain lens glass) joins the default colour so it dedupes with its labelled packs
    function withColor(list) {
      return list.map(function (c) { c.color = c.color || colorDefault; return c; });
    }
    var combos = addTriple(withColor(JSON.parse(row.getAttribute('data-combos') || '[]')), tripleMils);
    var typeSelect = row.querySelector('[data-cm-addon-type]');
    var colorSelect = row.querySelector('[data-cm-addon-color]');
    var packSelect = row.querySelector('[data-cm-addon-pack]');
    var ctl = packSelect ? packSelect.closest('.cm-addon__ctl') : null;
    var check = row.querySelector('[data-cm-addon-check]');
    var priceEl = row.querySelector('[data-cm-addon-price]');
    var thumb = row.querySelector('[data-cm-addon-thumb]');
    var titleEl = row.querySelector('[data-cm-addon-title]');
    var subEl = row.querySelector('[data-cm-addon-sub]');
    var defaultType = row.getAttribute('data-default-type');
    var titleTpl = row.getAttribute('data-title-template') || '%TYPE%';
    var packOne = row.getAttribute('data-pack-one') || '1';
    var packOther = row.getAttribute('data-pack-other') || '2';
    if (!combos.length || !packSelect || !check) return null;

    function packLabel(n) {
      return (n === 1 ? packOne : packOther).replace(/\d+/, String(n));
    }
    function currentType() {
      return typeSelect ? typeSelect.value : combos[0].type_handle;
    }
    function currentColor() {
      if (colorSelect && !colorSelect.hidden) return colorSelect.value;
      var list = colorsForType(currentType());
      return list.length ? list[0] : '';
    }
    // default colour first, the rest in listing order; the screen row has one colour and shows no select
    function colorsForType(handle) {
      var seen = {}, out = [];
      combos.forEach(function (c) {
        if (c.type_handle !== handle || seen[c.color]) return;
        seen[c.color] = true;
        out.push(c.color);
      });
      return out.sort(function (a, b) { return (a === colorDefault ? 0 : 1) - (b === colorDefault ? 0 : 1); });
    }
    // one rank list for every protector-type listing: plain types first, applicator variants after, unknown last
    var TYPE_RANK = ['normaal', 'full', 'privacy', 'matte', 'matte_privacy', 'combo', 'full_applicator', 'privacy_applicator', 'cameralens_shield', 'cameralens_ring', 'cameralens'];
    function typeRank(handle) {
      var i = TYPE_RANK.indexOf(handle);
      return i === -1 ? TYPE_RANK.length : i;
    }
    function distinctTypes() {
      var seen = {}, out = [];
      combos.forEach(function (c) {
        if (!seen[c.type_handle]) {
          seen[c.type_handle] = true;
          out.push({ handle: c.type_handle, name: c.type_name });
        }
      });
      return out.sort(function (a, b) {
        return typeRank(a.handle) - typeRank(b.handle) || a.handle.localeCompare(b.handle);
      });
    }
    function packsForType(handle, color) {
      var seen = {};
      return combos
        .filter(function (c) { return c.type_handle === handle && c.color === color; })
        .filter(function (c) { if (seen[c.pack]) return false; seen[c.pack] = true; return true; })
        .sort(function (a, b) { return a.pack - b.pack; });
    }
    // duplicate type+colour+pack combos (multi-EAN listings) resolve to the available one
    function findCombo(handle, color, pack) {
      var matches = combos.filter(function (c) { return c.type_handle === handle && c.color === color && c.pack === pack; });
      var available = matches.filter(function (c) { return c.available; });
      return available[0] || matches[0] || null;
    }
    function populateTypes() {
      if (!typeSelect) return;
      typeSelect.innerHTML = '';
      distinctTypes().forEach(function (t) {
        var opt = document.createElement('option');
        opt.value = t.handle;
        opt.textContent = t.name;
        typeSelect.appendChild(opt);
      });
      if (defaultType && combos.some(function (c) { return c.type_handle === defaultType; })) typeSelect.value = defaultType;
    }
    function populateColors() {
      if (!colorSelect) return;
      var type = currentType();
      var colors = colorsForType(type);
      colorSelect.innerHTML = '';
      colors.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        colorSelect.appendChild(opt);
      });
      colorSelect.hidden = colors.length <= 1;
      if (!colors.length) return;
      var firstAvailable = colors.filter(function (name) {
        return combos.some(function (c) { return c.type_handle === type && c.color === name && c.available; });
      })[0];
      colorSelect.value = firstAvailable || colors[0];
    }
    function populatePacks() {
      var type = currentType();
      var color = currentColor();
      var packs = packsForType(type, color);
      packSelect.innerHTML = '';
      packs.forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c.pack;
        opt.textContent = packLabel(c.pack) + (c.synthetic ? ' (−' + tripleText + '%)' : '');
        packSelect.appendChild(opt);
      });
      if (!packs.length) return;
      packSelect.value = pickPack(packs.map(function (c) { return c.pack; }), function (n) {
        var c = findCombo(type, color, n);
        return !!(c && c.available);
      });
      // one pack has nothing to choose: the pack reads as plain sub text instead of a one-option select
      var single = packs.length === 1;
      packSelect.hidden = single;
      var colorShown = !!(colorSelect && !colorSelect.hidden);
      if (ctl) ctl.hidden = single && !typeSelect && !colorShown;
      if (subEl) {
        subEl.hidden = !single;
        subEl.textContent = single ? packLabel(packs[0].pack) : '';
      }
    }
    function update() {
      var combo = findCombo(currentType(), currentColor(), Number(packSelect.value));
      if (!combo) {
        check.checked = false;
        check.disabled = true;
        row.classList.add('cm-addon__row--oos');
        return;
      }
      var title = titleTpl.replace('%TYPE%', combo.type_name);
      var qty = combo.qty || 1;
      check.setAttribute('data-variant-id', combo.variant_id);
      check.setAttribute('data-quantity', qty);
      check.setAttribute('data-price-cents', combo.price_cents);
      check.setAttribute('data-title', title);
      if (titleEl) titleEl.textContent = title;
      if (thumb && combo.image) thumb.src = combo.image;
      renderPrice(priceEl, combo.unit_cents || combo.price_cents, qty, combo.available, combo.synthetic ? combo.pct_mils : promoMils);
      check.disabled = !combo.available;
      if (!combo.available) check.checked = false;
      row.classList.toggle('cm-addon__row--oos', !combo.available);
    }
    populateTypes();
    populateColors();
    populatePacks();
    update();
    if (typeSelect) typeSelect.addEventListener('change', function () { populateColors(); populatePacks(); update(); });
    if (colorSelect) colorSelect.addEventListener('change', function () { populatePacks(); update(); });
    packSelect.addEventListener('change', update);
    // rebuilds the selects from the surviving combos through the same render path; returns whether the row stays
    return function applyCombos(next) {
      // a device or storage event re-runs this: keep the shopper's type and pack when they survive the filter
      var keepType = typeSelect ? typeSelect.value : '';
      var keepColor = colorSelect ? colorSelect.value : '';
      var keepPack = packSelect.value;
      combos = addTriple(withColor(next), tripleMils);
      if (!combos.length) {
        check.checked = false;
        check.disabled = true;
        return false;
      }
      populateTypes();
      if (keepType && combos.some(function (c) { return c.type_handle === keepType; })) typeSelect.value = keepType;
      populateColors();
      if (keepColor && colorSelect && Array.prototype.some.call(colorSelect.options, function (o) { return o.value === keepColor; })) colorSelect.value = keepColor;
      populatePacks();
      if (Array.prototype.some.call(packSelect.options, function (o) { return o.value === keepPack; })) packSelect.value = keepPack;
      update();
      return true;
    };
  }

  // ── list rows (wallet, charger): one colour select over a configured product list, first available colour wins ──
  function wireListRow(row) {
    var combos = JSON.parse(row.getAttribute('data-combos') || '[]');
    var colorSelect = row.querySelector('[data-cm-addon-color]');
    var ctl = colorSelect ? colorSelect.closest('.cm-addon__ctl') : null;
    var check = row.querySelector('[data-cm-addon-check]');
    var priceEl = row.querySelector('[data-cm-addon-price]');
    var thumb = row.querySelector('[data-cm-addon-thumb]');
    var titleEl = row.querySelector('[data-cm-addon-title]');
    var subEl = row.querySelector('[data-cm-addon-sub]');
    if (!combos.length || !colorSelect || !check) return;

    function defaultIndex() {
      for (var i = 0; i < combos.length; i++) {
        if (combos[i].available) return i;
      }
      return 0;
    }
    function populate() {
      colorSelect.innerHTML = '';
      combos.forEach(function (c, i) {
        var opt = document.createElement('option');
        // index as the value: colour names are not unique enough to key a listing on
        opt.value = String(i);
        opt.textContent = c.color;
        colorSelect.appendChild(opt);
      });
      if (ctl) ctl.hidden = combos.length === 1;
    }
    function update() {
      var combo = combos[Number(colorSelect.value)];
      if (!combo) {
        check.checked = false;
        check.disabled = true;
        row.classList.add('cm-addon__row--oos');
        return;
      }
      check.setAttribute('data-variant-id', combo.variant_id);
      check.setAttribute('data-price-cents', combo.price_cents);
      // charger lists mix products, so their title follows the colour; wallet rows keep their locale title
      if (combo.title) {
        check.setAttribute('data-title', combo.title);
        if (titleEl) titleEl.textContent = combo.title;
      }
      if (subEl) subEl.textContent = combo.color;
      if (thumb && combo.image) thumb.src = combo.image;
      renderPrice(priceEl, combo.price_cents, 1, combo.available, promoMils);
      check.disabled = !combo.available;
      if (!combo.available) check.checked = false;
      row.classList.toggle('cm-addon__row--oos', !combo.available);
    }
    populate();
    colorSelect.value = String(defaultIndex());
    update();
    colorSelect.addEventListener('change', update);
  }

  var packRows = [];
  root.querySelectorAll('[data-cm-addon-row]').forEach(function (row) {
    var kind = row.getAttribute('data-kind');
    if (kind === 'screen' || kind === 'lens') {
      packRows.push({ row: row, apply: wirePackRow(row), all: JSON.parse(row.getAttribute('data-combos') || '[]') });
    } else if (kind === 'wallet' || kind === 'charger') {
      wireListRow(row);
    }
  });

  // ── active device: rows built for the primary device only stay when the shopper's device is proven to fit ──
  var primaryId = root.getAttribute('data-primary') || '';
  var compatIds = (root.getAttribute('data-compat-ids') || '').split(',').filter(Boolean);
  function tail(v) { return String(v).split('/').pop(); }
  function activeIds() {
    if (!window.cmActiveDevice) return null;
    var d = window.cmActiveDevice(compatIds);
    if (!d) return null;
    return (d.fvs && d.fvs.length ? d.fvs : [d.gid]).map(tail);
  }
  function setRowHidden(row, hide) {
    row.hidden = hide;
    var c = row.querySelector('[data-cm-addon-check]');
    if (hide && c) c.checked = false;
  }
  function applyDevice() {
    var ids = activeIds();
    packRows.forEach(function (p) {
      var kept = filterByFit(p.all, ids, primaryId);
      var show = kept.length > 0;
      if (p.apply) show = p.apply(kept) && show;
      setRowHidden(p.row, !show);
    });
    // a checkbox that cannot act must never render: only unhide once wired and at least one row remains
    root.hidden = !root.querySelector('[data-cm-addon-row]:not([hidden])');
  }
  if (window.cmActiveDeviceBind) window.cmActiveDeviceBind(applyDevice);
  else applyDevice();

  // analytics must never break the add flow: every publish is guarded and swallowed
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data);
    } catch (e) {}
  }
  function liveRows() { return Array.prototype.slice.call(root.querySelectorAll('[data-cm-addon-row]:not([hidden])')); }
  if ('IntersectionObserver' in window) {
    var viewObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (en) { return en.isIntersecting; })) return;
      viewObserver.unobserve(root);
      var rowsNow = liveRows();
      track('cm_addon_view', {
        product_id: root.dataset.productId,
        device_handle: root.dataset.device,
        kinds: rowsNow.map(function (r) { return r.dataset.kind; }),
        row_count: rowsNow.length
      });
    }, { threshold: 0.5 });
    viewObserver.observe(root);
  }
  root.addEventListener('change', function (evt) {
    var cb = evt.target;
    if (!cb || !cb.matches || !cb.matches('[data-cm-addon-check]')) return;
    var row = cb.closest('[data-cm-addon-row]');
    track('cm_addon_check', {
      product_id: root.dataset.productId,
      kind: row ? row.dataset.kind : '',
      variant_id: cb.dataset.variantId,
      checked: cb.checked,
      price_cents: Number(cb.dataset.priceCents) || 0
    });
  });

  // ── submit: host first (no sections), then one add.js per checked row, one drawer render at the end ──
  function checkedRows() {
    return Array.prototype.filter.call(root.querySelectorAll('[data-cm-addon-check]'), function (c) {
      var row = c.closest('[data-cm-addon-row]');
      return c.checked && !c.disabled && c.getAttribute('data-variant-id') && !(row && row.hidden);
    });
  }
  function jsonConfig(body) {
    var config = fetchConfig('javascript');
    config.body = JSON.stringify(body);
    return config;
  }
  // Dawn keeps the error wrapper inside <product-form>, next to the <form>, not within it
  var formHost = form.closest('product-form') || form;
  function showFormError(message) {
    var wrapper = formHost.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;
    var text = wrapper.querySelector('.product-form__error-message');
    if (text) text.textContent = message;
    wrapper.removeAttribute('hidden');
  }

  document.addEventListener('submit', function (evt) {
    if (evt.target !== form) return;
    var rows = checkedRows();
    // zero checked rows: Dawn's own product-form handler runs untouched
    if (!rows.length) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();

    var submitButton = form.querySelector('[type="submit"]') || document.querySelector('#ProductSubmitButton-' + formId.replace('product-form-', ''));
    if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;
    var spinner = submitButton.querySelector('.loading__spinner');
    var stickyButton = document.querySelector('.cm-sticky-atc__button[form="' + formId + '"]');
    var drawer = document.querySelector('cart-drawer');
    var errorWrapper = formHost.querySelector('.product-form__error-message-wrapper');
    if (errorWrapper) errorWrapper.setAttribute('hidden', '');

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    if (stickyButton) stickyButton.disabled = true;
    if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);

    var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var hostVariantId = (new FormData(form)).get('id');
    var hostQuantity = parseInt((new FormData(form)).get('quantity'), 10) || 1;
    var failed = [];
    var added = [];
    var hostResponse = null;

    function restore() {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
      if (stickyButton) stickyButton.disabled = false;
    }
    function addHost() {
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = new FormData(form);
      return fetch(routes.cart_add_url, config).then(function (r) { return r.json(); }).then(function (response) {
        if (response.status) throw Object.assign(new Error(response.description || response.message || 'add failed'), { host: true, response: response });
        hostResponse = response;
      });
    }
    function addRow(check, isLast) {
      var body = { id: Number(check.getAttribute('data-variant-id')), quantity: Number(check.getAttribute('data-quantity')) || 1 };
      if (isLast && sectionIds.length) {
        body.sections = sectionIds;
        body.sections_url = window.location.pathname;
      }
      return fetch(routes.cart_add_url, jsonConfig(body))
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            failed.push(check.getAttribute('data-title') || '');
            return null;
          }
          added.push(check);
          return res.json;
        })
        .catch(function () {
          failed.push(check.getAttribute('data-title') || '');
          return null;
        });
    }
    function sectionsComplete(state) {
      return !!(state && state.sections && sectionIds.every(function (id) { return state.sections[id]; }));
    }
    function fetchSections() {
      return fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
        .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
        .then(function (json) { return { sections: json }; });
    }
    function render(state) {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: hostVariantId, cartData: hostResponse });
      }
      drawer.renderContents(state);
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      // renderContents swaps #CartDrawer synchronously, so the error node has to be looked up after it
      if (failed.length) {
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.innerHTML = '';
          failed.forEach(function (title) {
            var p = document.createElement('p');
            p.className = 'cm-addon__drawer-error';
            p.textContent = errorTemplate.replace('%TITLE%', title);
            errors.appendChild(p);
          });
        }
      }
    }

    addHost()
      .then(function () {
        var chain = Promise.resolve(null);
        rows.forEach(function (check, i) {
          chain = chain.then(function () { return addRow(check, i === rows.length - 1); });
        });
        return chain;
      })
      .then(function (lastState) {
        if (added.length) {
          track('cm_addon_add', {
            product_id: root.dataset.productId,
            kinds: added.map(function (c) { var r = c.closest('[data-cm-addon-row]'); return r ? r.dataset.kind : ''; }),
            count: added.length,
            total_cents: added.reduce(function (sum, c) { return sum + (Number(c.dataset.priceCents) || 0); }, 0)
          });
        }
        if (!drawer || typeof drawer.renderContents !== 'function') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (sectionsComplete(lastState)) {
          render(lastState);
          return;
        }
        return fetchSections().then(render, function () {
          // the adds already happened: never leave the shopper without the cart
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        });
      })
      .catch(function (e) {
        if (e && e.host) {
          showFormError(e.message);
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: hostVariantId, errors: e.response && (e.response.errors || e.response.description), message: e.message });
          }
        } else {
          showFormError((window.cartStrings && window.cartStrings.error) || e.message);
        }
      })
      .finally(restore);
  }, true);
})();
